import ArkLoader from '@src/js/common/ark-extensions';
import { IExtension } from '@tencent/ark-extensions';
import { PDF_TO_OFFICE } from './component-config';

export async function pdfToOffice(options?: any): Promise<IExtension> {
    const arkService = ArkLoader.extensionService;
    await arkService.scanAndHandleExtensions([PDF_TO_OFFICE]);
    const pdfToOffice = await ArkLoader.extensionService.getExtension(PDF_TO_OFFICE.name);
    pdfToOffice.show(options);
    return pdfToOffice;
}
